<template>
  <li class="filter-option">
    <a
      v-if="filter.hasUrl && option.urlPath"
      :href="option.urlPath + '/'"
      class="filter-option__link"
      :class="{ 'filter-option__link--active': option.toBeSelected }"
      @click.prevent="$emit('option-toggle', option.key)"
    >
      <span
        class="filter-option__input checkbox"
        :class="{ 'checkbox--checked': option.selected }"
      />

      <span class="filter-option__label">
        <span
          v-if="filter.type === 'swatch'"
          class="filter-option__swatch"
          :style="swatchBg(option)"
        />
        <span class="filter-option__name">{{ label }}</span>
        <span class="filter-option__count">{{ option.count }}</span>
      </span>
    </a>
    <template v-else>
      <input
        :id="`filter-${filter.key}-${option.key}`"
        type="checkbox"
        class="filter-option__input"
        :checked="option.selected"
        @input="$emit('option-toggle', option.key)"
      >
      <label
        class="filter-option__label"
        :for="`filter-${filter.key}-${option.key}`"
      >
        <span
          v-if="filter.type === 'swatch'"
          class="filter-option__swatch"
          :style="swatchBg(option)"
        />
        <span class="filter-option__name">{{ label }}</span>
        <span class="filter-option__count">{{ option.count }}</span>
      </label>
    </template>
  </li>
</template>

<script setup lang="ts">
export type Props = {
  option: any
  filter: any
}

const props = defineProps<Props>()
defineEmits(['option-toggle'])

const label = computed(() => {
  return props.option.label
})

// const { public: config } = useRuntimeConfig()

function swatchBg(option: any) {
  if (['multicolor', 'mehrfarbig'].includes(option.key.toLowerCase())) {
    return {
      backgroundBlendMode: 'screen',
      backgroundImage: `
        radial-gradient(circle closest-side, white, black 90%),
        conic-gradient(red, #ff8000, yellow, #80ff00, lime, #00ff80, aqua, #0080ff, blue, #8000ff, fuchsia, #ff0080, red)
      `,
    }
  }

  return {
    backgroundColor: option.swatch,
  }
}
</script>

<style src="~layers/app/components/Filter/Option.css" />
